import { TableCell, TableHeadCell } from "../../../kit/Table"
import { ContentWarningModal } from "./ContentWarningModal"



export const BackupWarningModal = ({ onClose, data }) => {

    return (
        <ContentWarningModal onClose={onClose} title={`Following backup${data.errors.length > 1 ? "s were" : " is"} not triggered`}
            warningContent={
                <table className="min-w-full divide-y divide-gray-300">
                    <thead>
                        <tr>
                            <TableHeadCell className="font-weight-bold rounded-tl-lg" scope="row">Repository</TableHeadCell>
                            <TableHeadCell className="font-weight-bold rounded-tr-lg" scope="row">Reason</TableHeadCell>
                        </tr>
                    </thead>
                    <tbody>
                        {data.errors.map((error) =>
                            <tr key={error.repositoryId}>
                                <TableCell>{error.owner}/{error.repositoryName}</TableCell>
                                <TableCell><span className="break-words">{error.reason}</span></TableCell>
                            </tr>
                        )}
                    </tbody>
                </table>}
        />
    )
}